import { useHistory } from "react-router-dom";
import { useI18n } from "i18n";
import { PAGES, usePageTracking } from "modules/tracking";
import { Typography } from "@remo-co/ui-core/src/components/Typography";
import { Button } from "@remo-co/ui-core/src/components/Button";
import { Box } from "@remo-co/ui-core/src/components/Box";
import EDCVirtualLogo from "../assets/edc-virtual-logo.png";
import { styles } from "./styles";

export const EDCLoginError = () => {
  const history = useHistory();
  const { t } = useI18n(["common", "errorPage"]);

  usePageTracking(PAGES.EDC_LOGIN_ERROR);

  return (
    <Box sx={styles.root}>
      <Box sx={styles.container}>
        <Box
          sx={styles.logo}
          component="img"
          alt={t(`auth:edc.virtual.login.alt`)}
          src={EDCVirtualLogo}
        />
        <Typography sx={styles.header}>
          {t(`auth:edc.login.error.header`)}
        </Typography>
        <Typography sx={styles.description}>
          {t(`auth:edc.login.error.description.1`)}
        </Typography>
        <Typography sx={styles.description}>
          {t(`auth:edc.login.error.description.2`)}
        </Typography>
        <div>
          <Button
            variant="primary"
            size="lg"
            fullWidth
            sx={styles.button}
            onClick={() => history.push("/signin")}
          >
            {t(`auth:back.to.login`)}
          </Button>
        </div>
      </Box>
    </Box>
  );
};
